import { useState } from 'preact/hooks';
import { route } from 'preact-router';
import Button from '../components/shared/Button.jsx';
import TabNav from '../components/TabNav.jsx';
import MrrTile from '../components/MrrTile.jsx';
import ProductsView from './Products.jsx';
import DebtorsView from './Debtors.jsx';
import SubscriptionsView from './Subscriptions.jsx';
import InvoicesView from './Invoices.jsx';
import SyncStatusView from './SyncStatus.jsx';
import SettingsView from './Settings.jsx';

const TABS = [
  { id: 'products',      label: 'Producten' },
  { id: 'debtors',       label: 'Debiteuren' },
  { id: 'subscriptions', label: 'Abonnementen' },
  { id: 'invoices',      label: 'Facturen' },
  { id: 'sync',          label: 'Ophaalstatus' },
  { id: 'settings',      label: 'Instellingen' }
];

export default function DashboardView({ auth, onLogout }) {
  const [tab, setTab] = useState('products');
  // Why: de MRR-tegel leest uit dezelfde abonnementen die de tabbladen muteren.
  // Een bump laat hem meteen herladen in plaats van tot de volgende poll te wachten.
  const [dataVersion, setDataVersion] = useState(0);
  const bump = () => setDataVersion(v => v + 1);

  async function logout() {
    try {
      const res = await fetch('/api/auth/logout', { method: 'POST', credentials: 'same-origin' });
      if (!res.ok) return;
      onLogout?.();
      route('/login', true);
    } catch {
      // netwerkfout — laat de ingelogde state staan
    }
  }

  return (
    <div class="dashboard-shell">
      <header class="dashboard-header">
        <div class="brand">4U</div>
        <div class="header-right">
          <span class="muted">Ingelogd als <strong>{auth?.displayName || 'admin'}</strong></span>
          <Button variant="ghost" onClick={logout}>Uitloggen</Button>
        </div>
      </header>

      <main class="dashboard-main">
        <MrrTile refreshKey={dataVersion} />
        <TabNav tabs={TABS} current={tab} onChange={setTab} />

        {tab === 'products' && <ProductsView onChanged={bump} />}
        {tab === 'debtors' && <DebtorsView onChanged={bump} />}
        {tab === 'subscriptions' && <SubscriptionsView onChanged={bump} />}
        {tab === 'invoices' && <InvoicesView onChanged={bump} />}
        {tab === 'sync' && <SyncStatusView />}
        {tab === 'settings' && <SettingsView />}
      </main>
    </div>
  );
}
